import { getAuthSession } from './api';

export default function navigateToLogin() {
    const params = getAuthSession();
    if (params.type) {
        window.open(loginURLWithParams(params), '_self');
    } else {
        window.open('/login', '_self');
    }
    this.initLogin();
}

function hasLoginParams(params) {
    return params.type || params.sId || params.eId;
}

export function loginURLWithParams(params) {
    let url = '/login';
    if (hasLoginParams(params)) url = `${url}?`;
    url = appendWhenAvailable(url, params, 'type');
    url = appendWhenAvailable(url, params, 'sId');
    url = appendWhenAvailable(url, params, 'eId');
    url = appendWhenAvailable(url, params, 'uId');
    return removeLastChar(url, '&');
}

function appendWhenAvailable(url, params, name) {
    if (params[name]) return `${url}${name}=${params[name]}&`;
    return url;
}

function removeLastChar(url, charValue = '&') {
    const lastChar = url[url.length - 1];
    if (lastChar === charValue) return url.slice(0, -1);
    return url;
}
